<script>
import { mapState } from 'vuex'
export default {
  name: 'currencyInput',
  props: {
    currencyId: {
      type: Number,
      default: () => undefined
    },
    readonly: {
      type: Boolean,
      default: () => false
    },
    isDefault: {
      type: Boolean,
      default: () => false
    },
    value: {
      default: 0
    },
    placeholder: {
      type: String,
      default: () => 'input'
    }
  },
  computed: {
    ...mapState('saleInvoiceStore', ['currencies']),
    currencySign() {
      return this.currencies.map(el => ({
        value: el.currency_id,
        label: el.currency_symbol
      }))
    },
    defaultPrecision() {
      return this.$store.state.authUser.sys_setting.decimal_digit
    },
    currencySignById() {
      if (this.currencies) {
        const currency = this.currencies.find(
          c => c.currency_id === this.currencyId
        )
        return currency ? currency.currency_symbol : ''
      }

      return '-'
    }
  },
  methods: {
    onInput(event) {
      // Emit the input event with the new value
      this.$emit('input', event.target.value)
    },
    onCurrencyChange(event) {
      // Emit currency-change event with the new currency ID
      this.$emit('currency-change', Number(event.target.value))
    }
  }
}
</script>

<template>
  <div
    class="ts-flex ts-w-full ts-items-center ts-px-1 ts-overflow-hidden"
    :attrs="$attrs"
  >
    <div v-if="!isDefault" class="ts-flex ts-items-center">
      <select
        :value="currencyId"
        class="ts-outline-none ts-text-center ts-w-6 ts-cursor-pointer ts-bg-gray-400"
        :disabled="readonly"
        @change="onCurrencyChange"
      >
        <option
          v-for="(c, index) in currencySign"
          :key="index"
          :value="c.value"
          >{{ c.label }}</option
        >
      </select>
      <input
        :value="value"
        @input="onInput"
        :placeholder="placeholder"
        type="number"
        class="ts-outline-none ts-w-full"
        :readonly="readonly"
      />
    </div>
    <div v-else class="ts-px-1 ts-space-x-2">
      <span>{{ currencySignById }}</span>
      <span>{{ $formatNumber(value, defaultPrecision) }}</span>
    </div>
  </div>
</template>

<style scoped>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
  background: transparent;
}

select {
  appearance: none;
  background: transparent;
}
</style>
